import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PlaceOutingSignal {
  place_id: string;
  slug: string;
  name: string;
  municipality: string | null;
  landskap: string | null;
  lat: number | null;
  lng: number | null;
  has_farm_shop: boolean;
  has_farm_sale_alcohol: boolean;
  next_event_at: string | null;
  event_count_next_30d: number;
  intent_keys: string[];
}

/**
 * Fetches aggregated outing signals per place.
 * Used for the "Förslag nära dig" Explore section.
 */
export function usePlaceOutingSignals(limit = 20) {
  return useQuery({
    queryKey: ["place-outing-signals-v0", limit],
    queryFn: async (): Promise<PlaceOutingSignal[]> => {
      const { data, error } = await supabase.rpc("get_place_outing_signals_v0", {
        p_limit: limit,
      });

      if (error) {
        console.error("get_place_outing_signals_v0 error:", error);
        return [];
      }

      return (data ?? []).map((row: any) => ({
        place_id: row.place_id,
        slug: row.slug,
        name: row.name,
        municipality: row.municipality,
        landskap: row.landskap,
        lat: row.lat,
        lng: row.lng,
        has_farm_shop: row.has_farm_shop ?? false,
        has_farm_sale_alcohol: row.has_farm_sale_alcohol ?? false,
        next_event_at: row.next_event_at,
        event_count_next_30d: Number(row.event_count_next_30d) || 0,
        intent_keys: row.intent_keys ?? [],
      }));
    },
    staleTime: 5 * 60 * 1000,
  });
}
